import { AxiosResponse } from 'axios'

const FALLBACK_CONTENT_TYPE = 'application/octet-stream'

const getFilename = (response: AxiosResponse<unknown>, fallback: string) => {
  const contentDisposition = response.headers['content-disposition']

  if (contentDisposition && contentDisposition.includes('filename=')) {
    return contentDisposition.split('filename=')[1].split(';')[0].replace(/"/g, '')
  }

  return fallback
}

/**
 * Saves a blob response to disk, taking the filename from `Content-Disposition`
 * and the MIME type from `Content-Type` so the same helper works for pdf, csv
 * and xlsx exports.
 */
export const downloadFile = (response: AxiosResponse<unknown>, fallbackFilename: string) => {
  const contentType = response.headers['content-type'] || FALLBACK_CONTENT_TYPE
  const blob = new Blob([response.data as BlobPart], { type: contentType })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = getFilename(response, fallbackFilename)
  link.click()

  // Clean up the object URL after download
  URL.revokeObjectURL(link.href)
}

export const downloadPDF = (response: AxiosResponse<unknown>) =>
  downloadFile(response, 'downloaded-file.pdf')

export const getProgress = (progressEvent: any) => {
  return Math.round((progressEvent.loaded * 100) / progressEvent.total)
}
